import { render, staticRenderFns } from "./weixinMessage.vue?vue&type=template&id=d64ca0d2&"
import script from "./weixinMessage.vue?vue&type=script&lang=js&"
export * from "./weixinMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports